export default __webpack_public_path__ + "static/media/BW-logo.59a23bc5.png";